import * as React from "react";
import {Component} from "react";

interface IWeatherConditionProps {
    data: any;
    unitType: string;
}

class WeatherCondition extends Component<IWeatherConditionProps, {}> {
    public render() {
        const data = this.props.data;

        return (
            <React.Fragment>
                {
                    data.condition ? <div>
                        <div style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            fontWeight: 'bold'
                        }}>
                            {data.condition.text}
                        </div>
                        <img
                            style={{
                                display: 'inline-block',
                                verticalAlign: 'middle',
                                marginLeft: '10px'
                            }}
                            alt="Image"
                            src={data.condition.icon}
                        />
                        <div style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginLeft: '10px',
                            fontSize: '32px'
                        }}>
                            {
                                this.props.unitType === 'celsius' ? <React.Fragment>
                                    <b>{data.temp_c}</b><sup>&#176;{"C"}</sup>
                                </React.Fragment> : <React.Fragment>
                                    <b>{data.temp_f}</b><sup>&#176;{"F"}</sup>
                                </React.Fragment>
                            }
                        </div>
                    </div> : <></>
                }
            </React.Fragment>
        );
    }

}

export default WeatherCondition;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Weather/WeatherCondition.tsx